var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "next" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", icon: "el-icon-arrow-right" },
            on: { click: _vm.backToTop }
          },
          [_vm._v("業務選択画面へ戻る")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message_area" }, [
      _vm._v("\n    お申込みがキャンセルされました。"),
      _c("br"),
      _vm._v(
        "タブレットをお持ちの場合、タブレットを販売員にお渡しください。\n  "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }